<div class="error-snack-bar-container">
  <div class="text">
    <span *ngIf="data.message" class="message" [ngClass]="{bold: data.detail}">{{data.message}}</span>
    <span *ngIf="data.detail" class="detail">{{data.detail}}</span>
  </div>
  <div class="button">
    <button mat-button (click)="snackBarRef.dismiss()">Dismiss</button>
  </div>
</div>